import React from 'react'
import classNames from 'classnames'

import ActionMenu from 'components/ActionMenu'
import VerticalButtonMenu from 'components/VerticalButtonMenu'
import './GridListTdActions.scss'

const GridListTdActions = ({ itemData, menuItems, color, actions, gridView, disableMobile, actionsAlwaysVisible }) => {

  return (
    <td className={
      classNames(
        'viso-grid-list-td viso-grid-list-td--actions',
        `viso-grid-list-td--actions--${actions?.length}`,
        `viso-grid-list-td--${gridView} viso-grid-list-td--actions--${gridView}`
      )}
    >
      <div className={classNames('viso-grid-list-actions', `viso-grid-list-actions--${gridView}`, !disableMobile && 'viso-grid-list-actions--mobile-enabled', actionsAlwaysVisible && 'viso-grid-list-actions--always-visible')}>
        {actions?.length > 0 &&
          <div className={classNames('viso-grid-list-actions__list', `viso-grid-list-actions__list--${gridView}`, !disableMobile && 'viso-grid-list-actions__list--mobile-enabled', disableMobile && gridView === 'card' && 'viso-grid-list-actions__list--card--full',)}>
            {actions
              .map((action, index) =>
                !(typeof action.hideItem === 'function' ? action.hideItem(itemData) : !!action.hideItem) &&
                <div
                  key={index}
                  className={classNames('viso-grid-list-actions__item', color && `viso-grid-list-actions__item--${color}`, typeof action.className === 'function' ? action.className(itemData) : action.className)}
                  onClick={(e) => {
                    e.stopPropagation()
                    action?.onClick(itemData)
                  }}
                >
                  <span
                    className='viso-grid-list-actions__icon'
                    data-tooltip-id='tooltipPortal'
                    data-tooltip-content={action.label}
                  >
                    {typeof action.icon === 'function' ? action.icon(itemData) : action.icon}
                  </span>
                </div>
              )}
          </div>
        }
        {menuItems?.length > 0 &&
          <VerticalButtonMenu color={color}>
            {menuItems.map((item, index) => {
              if(typeof item.hideItem === 'function' ? item.hideItem(itemData) : !!item.hideItem) return null
              return item.isDivider ? <React.Fragment key={index}><hr /></React.Fragment> : 
                <ActionMenu
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation()
                    item.onClick(itemData)
                  }}
                  icon={item.icon}
                  text={item.label}
                  disabled={item.disabledCheck ? item.disabledCheck(itemData) : item.disabled}
                  className={item.className}
                  type={item.type}
                  to={item.to}
                />
            })}
          </VerticalButtonMenu>
        }
      </div>
    </td>
  )
}

export default GridListTdActions